import { axios } from '@Root/API'

export const edit = (studyProgrammeId, courseReferenceId, payload) => {
	return axios.post(`program/${studyProgrammeId}/course-reference/${courseReferenceId}`, payload)
}
